<template>
    <van-swipe-cell :on-close="onClose">
        <!-- 八字记录列表元素基类 -->
        <record-item
            v-bind:recordData="recordData"
            v-bind:itemFunc="itemFunc">
        </record-item>
        <template slot="right">
            <div class="com-record-delete">删除</div>
        </template>
    </van-swipe-cell>
</template>

<script>
/**
 * 记录列表可删除元素基类
 */
import RecordItem from './RecordItem.vue'
export default {
    name: 'RecordDeleteItem',
    components: { RecordItem },
    props: {
        recordData: {
            type: Object,
            default () { return {} }
        },
        itemFunc: {
            type: Function,
            default() { return undefined }
        }
    },
    methods: {
        clickRecordItem() {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc(this.recordData);
            }
        },
        onClose(clickPosition, instance) {
            var me = this, msg = '';
            if(this.recordData.pipan || this.recordData.nunpan || this.recordData.reminder ||this.recordData.ai) {
                msg = msg+'待删除八字存在';
                msg = this.recordData.pipan ? msg+'批盘、' : msg;
                msg = this.recordData.nunpan ? msg+'论盘、' : msg;
                msg = this.recordData.reminder ? msg+'生日提醒、' : msg;
                msg = this.recordData.ai ? msg+'测算结果、' : msg;
                msg = msg.charAt(msg.length-1)=='、' ? msg.slice(0, -1) : msg;
                msg = msg+'数据，\n删除不可恢复';
            }
            switch (clickPosition) {
                case 'cell':
                case 'outside':
                    instance.close();
                    break;
                case 'right':
                    me.$bus.emit('showDeleteRecordItemPop', {
                        text1: '确定要删除这一条记录吗？',
                        text2: msg,
                        cb: function() {
                            me.$store.dispatch('record/deleteRecordData', me.recordData.id);
                            instance.close();
                        }
                    })
                break;
            }
        } 
    }
}
</script>